import "./ProfileSkeletonNonMemUser.css";

export default function ProfileSkeletonNonMemUser() {
  return (
    <div className="profile-skeleton-page">
      {/* Profile Header Card */}
      <div className="skcard skeleton-card">
        <div className="profile-header">
          <div className="avatar skeleton shimmer" />

          <div className="profile-meta">
            <div className="sk-line lg shimmer" />
            <div className="sk-line md shimmer" />
            <div className="sk-line sm shimmer" />
          </div>

          <div className="header-actions">
            <div className="sk-btn shimmer" />
          </div>
        </div>
      </div>

      {/* Like / Connection Stats */}
      <div className="skcard skeleton-card stats">
        <div className="stat shimmer" />
        <div className="stat shimmer" />
      </div>

      {/* Company Card */}
      <div className="skcard skeleton-card">
        <div className="company-row">
          <div className="qr shimmer" />

          <div className="company-meta">
            <div className="sk-line md shimmer" />
            <div className="sk-line sm shimmer" />
          </div>
        </div>

        <div className="social-row">
          {[...Array(6)].map((_, i) => (
            <div key={i} className="sk-social-icon shimmer" />
          ))}
        </div>
      </div>

      {/* Contact Details */}
      <div className="skcard skeleton-card">
        <div className="sk-line md shimmer sk-mb" />
        {[...Array(4)].map((_, i) => (
          <div key={i} className="contact-row">
            <div className="sk-icon shimmer" />
            <div className="sk-line sm shimmer" />
          </div>
        ))}
        <div className="sk-btn wide shimmer sk-mt" />
      </div>
    </div>
  );
}
